import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface IInputGroupTextProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
}

export const InputGroupText: React.FunctionComponent<IInputGroupTextProps> = ({
  children,
  className,
  testId,
}) => {
  return (
    <span
      className={C(className && className, 'rc-text-center', 'rc-w-full')}
      data-testid={testId}
    >
      {children}
    </span>
  );
};
